export interface FieldDef {
  key: string;
  label: string;
}

export interface FieldGroup {
  id: string;
  label: string;
  fields: FieldDef[];
}

export const FIELD_GROUPS: FieldGroup[] = [
  {
    id: 'session',
    label: 'Sitzung',
    fields: [
      { key: 'startDateTime',                 label: 'Startzeit' },
      { key: 'startDate',                     label: 'Startdatum' },
      { key: 'startTime',                     label: 'Startzeit (nur Zeit)' },
      { key: 'endDateTime',                   label: 'Endzeit' },
      { key: 'endDate',                       label: 'Enddatum' },
      { key: 'endTime',                       label: 'Endzeit (nur Zeit)' },
      { key: 'connectDateTime',               label: 'Verbindungszeitpunkt' },
      { key: 'connectDate',                   label: 'Verbindungsdatum' },
      { key: 'connectTime',                   label: 'Verbindungszeit (nur Zeit)' },
      { key: 'duration',                      label: 'Gesamtdauer (s)' },
      { key: 'connectingDuration',            label: 'Verbindungsdauer (s)' },
      { key: 'connectedDuration',             label: 'Gesprächsdauer (s)' },
      { key: 'result',                        label: 'Ergebnis' },
      { key: 'priority',                      label: 'Priorität' },
      { key: 'route',                         label: 'Route' },
      { key: 'routeEstablishType',            label: 'Route-Typ' },
      { key: 'node',                          label: 'Node' },
      { key: 'incomingCallNode',              label: 'Node (eingehend)' },
      { key: 'outgoingCallNode',              label: 'Node (ausgehend)' },
      { key: 'sessionIdentifier',             label: 'Sitzungs-ID' },
      { key: 'systemIdentifier',              label: 'System-ID' },
      { key: 'inboundSourceDialString',       label: 'Anrufer' },
      { key: 'inboundDestinationDialString',  label: 'Angerufene Nummer (eingehend)' },
      { key: 'outboundSourceDialString',      label: 'Ausgehende Quellnummer' },
      { key: 'outboundDestinationDialString', label: 'Weiterleitungsziel' },
      { key: 'inboundSourceDisplayName',      label: 'Anzeigename Anrufer' },
      { key: 'inboundDestinationDisplayName', label: 'Anzeigename Ziel (eingehend)' },
      { key: 'outboundSourceDisplayName',     label: 'Anzeigename Quelle (ausgehend)' },
      { key: 'outboundDestinationDisplayName',label: 'Anzeigename Ziel (ausgehend)' },
      { key: 'terminatedBy',                  label: 'Beendet von' },
      { key: 'mediaForwarderMode',            label: 'Media-Forwarder-Modus' },
      { key: 'anynodeVersion',                label: 'Anynode-Version' },
      { key: 'usesRegistration',              label: 'Registrierung genutzt' },
      { key: 'initiatingIpAddress',           label: 'Initiierende IP-Adresse' },
      { key: 'redirectTo',                    label: 'Umgeleitet zu' },
      { key: 'cpuUsagePeak',                  label: 'CPU-Peak (%)' },
      { key: 'cpuUsageAverage',               label: 'CPU-Durchschnitt (%)' },
      { key: 'memoryUsagePeak',               label: 'Speicher-Peak' },
      { key: 'memoryUsageAverage',            label: 'Speicher-Durchschnitt' },
      { key: 'inUseSessions',                 label: 'Aktive Sitzungen' },
    ],
  },
  {
    id: 'incoming',
    label: 'Eingehender Anruf',
    fields: [
      { key: 'incomingCallSourceDialString',           label: 'Quellnummer' },
      { key: 'incomingCallDestinationDialString',      label: 'Zielnummer' },
      { key: 'incomingCallSourceDisplayName',          label: 'Anzeigename Quelle' },
      { key: 'incomingCallDestinationDisplayName',     label: 'Anzeigename Ziel' },
      { key: 'incomingCallAssertedDialString',         label: 'Asserted DialString' },
      { key: 'incomingCallAssertedDisplayName',        label: 'Asserted Anzeigename' },
      { key: 'incomingCallResult',                     label: 'Ergebnis' },
      { key: 'incomingCallRoute',                      label: 'Route' },
      { key: 'incomingCallDuration',                   label: 'Dauer (s)' },
      { key: 'incomingCallConnectingDuration',         label: 'Verbindungsdauer (s)' },
      { key: 'incomingCallConnectedDuration',          label: 'Gesprächsdauer (s)' },
      { key: 'incomingCallStartDateTime',              label: 'Startzeit' },
      { key: 'incomingCallEndDateTime',                label: 'Endzeit' },
      { key: 'incomingCallConnected',                  label: 'Verbunden' },
      { key: 'incomingCallTerminatedBy',               label: 'Beendet von' },
      { key: 'incomingCallTeamsMode',                  label: 'Teams-Modus' },
      { key: 'incomingCallSignalingProtocol',          label: 'Signalisierungsprotokoll' },
      { key: 'incomingCallTransportProtocol',          label: 'Transportprotokoll' },
      { key: 'incomingCallRemoteUserAgent',            label: 'Remote User-Agent' },
      { key: 'incomingCallRegistrationClientName',     label: 'Registrierungsname' },
      { key: 'incomingCallTransportConnectionUri',     label: 'Verbindungs-URI' },
      { key: 'incomingCallSipCallId',                  label: 'SIP Call-ID' },
      { key: 'incomingCallMsCorrelationId',            label: 'MS Correlation-ID' },
      { key: 'incomingCallSipEndReason',               label: 'SIP-Beendigungsgrund' },
      { key: 'incomingCallSipStatusCode',              label: 'SIP-Statuscode' },
      { key: 'incomingCallSipSourceUri',               label: 'SIP-Quell-URI' },
      { key: 'incomingCallSipDestinationUri',          label: 'SIP-Ziel-URI' },
      { key: 'incomingCallMediaSendCodec',             label: 'Send-Codec' },
      { key: 'incomingCallMediaReceiveCodec',          label: 'Receive-Codec' },
      { key: 'incomingCallRtpReceivePacketsLost',      label: 'RTP-Empfang verloren' },
      { key: 'incomingCallRtpSendPacketsLost',         label: 'RTP-Senden verloren' },
      { key: 'incomingCallRtpReceiveTotalPackets',     label: 'RTP-Empfang gesamt' },
      { key: 'incomingCallRtpSendTotalPackets',        label: 'RTP-Senden gesamt' },
      { key: 'incomingCallGeoLocationOne',             label: 'Geostandort 1' },
      { key: 'incomingCallGeoLocationTwo',             label: 'Geostandort 2' },
      { key: 'incomingCallRecordingResult',            label: 'Aufzeichnungsergebnis' },
      { key: 'incomingCallXzrecRecordings',            label: 'XZREC-Aufzeichnungen' },
      { key: 'incomingCallWavRecordings',              label: 'WAV-Aufzeichnungen' },
      { key: 'incomingCallG711Recordings',             label: 'G711-Aufzeichnungen' },
    ],
  },
  {
    id: 'outgoing',
    label: 'Ausgehender Anruf',
    fields: [
      { key: 'outgoingCallSourceDialString',           label: 'Quellnummer' },
      { key: 'outgoingCallDestinationDialString',      label: 'Zielnummer' },
      { key: 'outgoingCallSourceDisplayName',          label: 'Anzeigename Quelle' },
      { key: 'outgoingCallDestinationDisplayName',     label: 'Anzeigename Ziel' },
      { key: 'outgoingCallAssertedDialString',         label: 'Asserted DialString' },
      { key: 'outgoingCallAssertedDisplayName',        label: 'Asserted Anzeigename' },
      { key: 'outgoingCallResult',                     label: 'Ergebnis' },
      { key: 'outgoingCallRoute',                      label: 'Route' },
      { key: 'outgoingCallDuration',                   label: 'Dauer (s)' },
      { key: 'outgoingCallConnectingDuration',         label: 'Verbindungsdauer (s)' },
      { key: 'outgoingCallConnectedDuration',          label: 'Gesprächsdauer (s)' },
      { key: 'outgoingCallStartDateTime',              label: 'Startzeit' },
      { key: 'outgoingCallEndDateTime',                label: 'Endzeit' },
      { key: 'outgoingCallConnected',                  label: 'Verbunden' },
      { key: 'outgoingCallTerminatedBy',               label: 'Beendet von' },
      { key: 'outgoingCallTeamsMode',                  label: 'Teams-Modus' },
      { key: 'outgoingCallSignalingProtocol',          label: 'Signalisierungsprotokoll' },
      { key: 'outgoingCallTransportProtocol',          label: 'Transportprotokoll' },
      { key: 'outgoingCallRemoteUserAgent',            label: 'Remote User-Agent' },
      { key: 'outgoingCallRegistrationClientName',     label: 'Registrierungsname' },
      { key: 'outgoingCallTransportConnectionUri',     label: 'Verbindungs-URI' },
      { key: 'outgoingCallSipCallId',                  label: 'SIP Call-ID' },
      { key: 'outgoingCallMsCorrelationId',            label: 'MS Correlation-ID' },
      { key: 'outgoingCallSipEndReason',               label: 'SIP-Beendigungsgrund' },
      { key: 'outgoingCallSipStatusCode',              label: 'SIP-Statuscode' },
      { key: 'outgoingCallSipSourceUri',               label: 'SIP-Quell-URI' },
      { key: 'outgoingCallSipDestinationUri',          label: 'SIP-Ziel-URI' },
      { key: 'outgoingCallMediaSendCodec',             label: 'Send-Codec' },
      { key: 'outgoingCallMediaReceiveCodec',          label: 'Receive-Codec' },
      { key: 'outgoingCallRtpReceivePacketsLost',      label: 'RTP-Empfang verloren' },
      { key: 'outgoingCallRtpSendPacketsLost',         label: 'RTP-Senden verloren' },
      { key: 'outgoingCallRtpReceiveTotalPackets',     label: 'RTP-Empfang gesamt' },
      { key: 'outgoingCallRtpSendTotalPackets',        label: 'RTP-Senden gesamt' },
      { key: 'outgoingCallGeoLocationOne',             label: 'Geostandort 1' },
      { key: 'outgoingCallGeoLocationTwo',             label: 'Geostandort 2' },
      { key: 'outgoingCallRecordingResult',            label: 'Aufzeichnungsergebnis' },
      { key: 'outgoingCallXzrecRecordings',            label: 'XZREC-Aufzeichnungen' },
      { key: 'outgoingCallWavRecordings',              label: 'WAV-Aufzeichnungen' },
      { key: 'outgoingCallG711Recordings',             label: 'G711-Aufzeichnungen' },
    ],
  },
];

export const FIELD_LABEL: Record<string, string> = Object.fromEntries(
  FIELD_GROUPS.flatMap((g) => g.fields.map((f) => [f.key, f.label]))
);

export const DEFAULT_FIELDS = ['startDateTime', 'inboundSourceDialString', 'outboundDestinationDialString'];
